import { SxProps, Theme } from '@mui/material'

export const styles: Record<string, SxProps<Theme>> = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  formControl: {
    minWidth: 200
  },
  clearFilters: {
    marginRight: '10px'
  },
  centerButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  },
  tableContainer: {
    maxHeight: '400px'
  }
}
